<div [class.fullscreen]="isFullScreen">
    <div class="action-category-container" [id]="componentId">
        <div class="action-category-summary-top-panel">
            <div class="action-category-summary-header lato-bold-dark">
                <div class="ltms-widget-title">
                    {{ title }}
                    <div class="action-category-summary-top-panel-discription ltms-description">
                        {{ description }}
                    </div>
                </div>
                <div class="action-category-summary-tools">
                    <!-- <app-ltms-widget-tools [config]='widgetConfig' [elementId]="widgetConfig.elementId"
                    (onViewChange)="onViewChange($event)" (onTrendTypeChange)="onTrendTypeChange($event, false)">
                </app-ltms-widget-tools> -->
                    <app-score-widget [config]="scoreWidget('barChart')" (onFullscreenClick)="onFullScreen($event)"
                        (onDownloadClick)="onDownload()" (onTrendClick)="onTrendTypeChange($event, false)"
                        (onChartTypeChange)="onViewChange($event)"></app-score-widget>
                </div>
            </div>
            <!-- <div class="action-category-summary-top-panel-discription ltms-description">
            {{ description }}
        </div> -->
        </div>
        <div *ngIf="isDataAvailable && isDataLoaded == true">
            <div class="bar-chart">
                <app-ltms-bar-chart-view [config]="chartData" [componentId]="chartId"
                    (onSelect)="onChartClick($event)"></app-ltms-bar-chart-view>
            </div>
        </div>
        <div *ngIf="!isDataAvailable && isDataLoaded == true">
            <app-ltms-error [code]="errorCode"></app-ltms-error>
        </div>
        <div class="data-details-loader" *ngIf="isDataLoaded == false">
            <app-ltms-loader></app-ltms-loader>
        </div>
    </div>
</div>